import React from 'react'
import { useParams } from 'react-router-dom'

import { Panel } from 'rsuite'

import LogisticTopMenu from '@components/logistic/LogisticTopMenu'
import ShopSlotForm from '@components/shop/slot/ShopSlotForm'

export default function EditDeliverySlotPage () {
  const { slotId } = useParams<{ slotId: string }>()

  return (
    <div>
      <h1 className="u-heading">Редактирование слота доставки</h1>
      <LogisticTopMenu />
      <Panel shaded>
        <ShopSlotForm slotId={slotId} />
      </Panel>
    </div>
  )
}
